import React from 'react';

/**
 * Official-style WhatsApp glyph (not the generic speech-bubble).
 * Renders inline; color comes from `currentColor` so callers can style with CSS.
 */
const WhatsAppIcon = ({ size = 18, className = '', ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    <path d="M19.05 4.91A10 10 0 0 0 4.36 18.31L3 22l3.78-1.32A10 10 0 0 0 22 12a9.94 9.94 0 0 0-2.95-7.09Zm-7.06 15.41h-.01a8.31 8.31 0 0 1-4.23-1.16l-.3-.18-2.93 1.02 1.04-2.86-.2-.31a8.32 8.32 0 1 1 6.63 3.49Zm4.56-6.22c-.25-.13-1.48-.73-1.71-.81-.23-.08-.39-.13-.56.13-.17.25-.65.81-.79.97-.15.17-.29.19-.54.07-.25-.13-1.06-.39-2.02-1.25a7.6 7.6 0 0 1-1.4-1.74c-.15-.25 0-.39.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.85-.2-.49-.41-.42-.56-.43-.15 0-.31 0-.48 0-.17 0-.43.06-.66.31s-.86.85-.86 2.07.88 2.4 1.01 2.57c.13.17 1.74 2.66 4.22 3.73.59.26 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.48-.6 1.7-1.18.21-.58.21-1.08.14-1.18-.06-.1-.22-.16-.47-.29Z" />
  </svg>
);

export default WhatsAppIcon;
